// extracted by mini-css-extract-plugin
export var actions = "_mk-d";
export var benefitCard = "_mk-a";
export var benefitIcon = "_mk-b";
export var benefitLabel = "_mk-c";
export var benefits = "_mk-9";
export var bodyText = "_mk-8";
export var closeButton = "_mk-2";
export var content = "_mk-3";
export var eyebrow = "_mk-4";
export var heading = "_mk-5";
export var image = "_mk-f";
export var imagePanel = "_mk-e";
export var modal = "_mk-0";
export var shell = "_mk-1";
export var title = "_mk-6";
export var titleOffer = "_mk-7";